import { useState } from "react";
import { useAppSelector } from "../../../lib/redux/hooks";
import { DownloadButton } from "../../../ui/icons/downloadButton";
import { PrintButton } from "../../../ui/icons/printButton";
import { Layout } from "../../../ui/layout";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { DownloadExcelProt } from "./downloadExcelProt";
import { FormDistintaEntrata } from "./formDistintaEntrata";
import './style.scss';

export function ReportProtocol() {

    const [openPopupEntrata, setOpenPopupEntrata] = useState<boolean>(false)
    const [openPopupEntrataConAllegati, setOpenPopupEntrataConAllegati] = useState<boolean>(false)
    const [openPopupExcel, setOpenPopupExcel] = useState<boolean>(false)
    const [protType, setProtType] = useState<string>('')
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const isDistintaLoading = entryProtocolState.getDistintaStatus === 'loading'
    const isExcelLoading = protType === 'entrata'
        ? entryProtocolState.getProtExcelStatus === 'loading'
        : departureProtocolState.getProtDepartureExcelStatus === 'loading'


    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Gestione Protocollo', 'Report']}
            noPaddingLat
            headerLabel="Report protocollo"
        >
            <div className="report-protocol-page grid grid-cols-1 xl:grid-cols-2 gap-6 p-6 pt-6">
                <div className="toolBox">
                    <div className="boxTitle">Protocollo Entrata</div>
                    <div className="boxBody p-6">
                        <div className="report-actions">
                            <div
                                className="bigButtonUtils report-action-card"
                                onClick={() => setOpenPopupEntrata(true)}
                                style={{ cursor: 'pointer', flex: '0.4', alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <PrintButton />
                                <div className="bodyLabel">Distinta di consegna</div>
                            </div>
                            <div
                                className="bigButtonUtils report-action-card"
                                onClick={() => setOpenPopupEntrataConAllegati(true)}
                                style={{ cursor: 'pointer', flex: '0.5', alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <PrintButton />
                                <div className="bodyLabel">Distinta di consegna con allegati</div>
                            </div>
                            <div
                                onClick={() => { setProtType('entrata'); setOpenPopupExcel(true); }}
                                className="bigButtonUtils report-action-card"
                                style={{ cursor: 'pointer', flex: '0.4', alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <DownloadButton />
                                <div className="bodyLabel" >Protocollo</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="toolBox">
                    <div className="boxTitle">Protocollo Partenza</div>
                    <div className="boxBody p-6">

                        <div className="report-actions">

                            <div
                                onClick={() => { setProtType('partenza'); setOpenPopupExcel(true); }}
                                className="bigButtonUtils report-action-card"
                                style={{ cursor: 'pointer', flex: '0.5', alignItems: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <DownloadButton />
                                <div className="bodyLabel" onClick={() => { setProtType('partenza'); setOpenPopupExcel(true) }}>Protocollo</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                (openPopupEntrata) && (
                    <PopupForm title="Distinta di consegna protocollo | Entrata" close={() => {
                        setOpenPopupEntrata(false)
                    }} disableClose={isDistintaLoading}>
                        <FormDistintaEntrata attachments={false} close={() => setOpenPopupEntrata(false)} />
                    </PopupForm>
                )
            }
            {
                (openPopupEntrataConAllegati) && (
                    <PopupForm title="Distinta di consegna con allegati | Entrata" close={() => {
                        setOpenPopupEntrataConAllegati(false)
                    }} disableClose={isDistintaLoading}>
                        <FormDistintaEntrata attachments={true} close={() => setOpenPopupEntrataConAllegati(false)} />
                    </PopupForm>
                )
            }

            {
                (openPopupExcel) && (
                    <PopupForm title="Scarica Excel" close={() => {
                        setOpenPopupExcel(false)
                    }} disableClose={isExcelLoading}>
                        <DownloadExcelProt protType={protType} close={() => setOpenPopupExcel(false)} />
                    </PopupForm>
                )
            }
        </Layout>
    )
}